import { format } from "date-fns";
import { IzobrazevanjeDetailType } from "../../types/Izobrazevanje/IzobrazevanjeDetailType";
import styled from "styled-components";
import timezoneShift from "../../utils/TimezoneShift";
import { IzobrazevanjeJavnoDetailType } from "../../types/Izobrazevanje/IzobrazevanjeJavnoDetailType";
import PdfViewer from "../../components/Common/PdfViewer";
import VideoPlayer from "../../components/Common/VideoPlayer";

const StyledIzobrazevanjeJavnoDetailForm = styled.div`
    h1, h3, p{
        font-weight: 350;
    }
    h1{
        font-size: 2rem;
        margin-top: 0;
        margin-bottom: 1rem;
    }
    h3{
        margin-top: 0;
        margin-bottom: 0.7rem;
    }
    p{
        margin-bottom: 0.7rem;
    }
    font-weight: 400;
    padding: 1.5rem;
    background-color: ${props => props.theme.colors.background};
    border: ${props => props.theme.colors.border} 1px solid;
    border-radius: 4px;
    margin-top:1rem;
    /*width: 50%;
    margin-bottom: 1rem; */
    @media (max-width: 900px){
        width: 90%;
    }
    .javnoContent{
        margin-bottom:1rem;
    }
`

type IzobrazevanjeJavnoDetailFormArgs = {
    izobrazevanje: IzobrazevanjeJavnoDetailType;
}

const IzobrazevanjeJavnoDetailForm = ({ izobrazevanje }: IzobrazevanjeJavnoDetailFormArgs) => {
    return (
        <StyledIzobrazevanjeJavnoDetailForm className="card">
            <h1>{`${izobrazevanje.naziv}`}</h1>
            {izobrazevanje.opis &&
                <p>
                    {`${izobrazevanje.opis}`}
                </p>}
            <p>Kategorija: <b>{`${izobrazevanje.izobrazevanjeTipNaziv}`}</b></p>
            <div className="javnoContent">
                {izobrazevanje.dokumentPredvajalnik === "pdf" &&
                    <PdfViewer pdfDocumentPath={izobrazevanje.dokumentPot} />
                }
                {izobrazevanje.dokumentPredvajalnik === "video" &&
                    <VideoPlayer videoDocumentPath={izobrazevanje.dokumentPot} />
                }
            </div>
        </StyledIzobrazevanjeJavnoDetailForm>
    );
}

export default IzobrazevanjeJavnoDetailForm;